module.exports = __webpack_public_path__ + "img/sld_right_arrow.f83ecd97.svg";